import React from "react";
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { BaseAppGlobalPopUp } from "./BaseAppGlobalPopUp";
import { reservationActions } from "../_actions/reservation.actions";

export function DeleteResevationsConfigGlobalPopUp() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return (
        <BaseAppGlobalPopUp
            title={t("reservations.deleteConfiguration")}
            body={body()}
            acceptButtonName={t("common.accept")}
            cancelButtonName={t("common.cancel")}
            onAccept={handleDelete}
        />
    );

    function body() {
        return t("reservations.allReservationsWillBeDeleted");
    }

    function handleDelete() {
        dispatch(reservationActions.deleteSelectedReservationConfig());
    }
}